import { render, staticRenderFns } from "./_iframe.vue?vue&type=template&id=03b3d7b6&scoped=true&"
import script from "./_iframe.vue?vue&type=script&lang=js&"
export * from "./_iframe.vue?vue&type=script&lang=js&"
import style0 from "./_iframe.vue?vue&type=style&index=0&id=03b3d7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b3d7b6",
  null
  
)

export default component.exports